import React, { useEffect, useState } from 'react';

import './styles.css';
import Popup from '../../../../../components/Popup';
import {FaFilter} from 'react-icons/fa';
import Input from '../../../../../components/Input';
import productServices from '../../../../../services/admFin/productServices';

export default function FilterProductsPopUp(props) {
    const [costCenters, setCostCenters] = useState([]);
    const [productsPlans, setproductsPlans] = useState([]);
    //const [status, setStatus] = useState([]);

    const [filterFields, setFilterFields] = useState({
        centro_de_custo: "",
        plano_de_contas: "",
        tipo: "",
        status: "Todos",
        nome: "",
        categoria: ""
    });

    async function readInfoNewProduct() {
        const response = await productServices.getInfoNewProduct();
        if (response.status === 200) {
            setCostCenters(response.data.centros_de_custo);
            setproductsPlans(response.data.planos_de_contas);
        } else
            alert("Erro ao ler informações auxiliares, tente novamente!");
    }

    useEffect(() => {
        readInfoNewProduct();
    }, []);

    useEffect(() => {
        if(props.products.length > 0)
            onFilter();
    }, [props.products]);


    function onFilter() {
        let auxArray = [...props.products];

        if(filterFields.nome !== "") {
            auxArray = auxArray.filter(obj => obj.nome.toLowerCase().includes(filterFields.nome.toLowerCase()));
        }

        if(filterFields.categoria !== "") {
            const categoria = productServices.productCategories.find(item => item[1] === filterFields.categoria)[0]
            auxArray = auxArray.filter(obj => obj.categoria === categoria);
        }

        if(filterFields.centro_de_custo !== "") {
            auxArray = auxArray.filter(obj => obj.centro_de_custo && obj.centro_de_custo.id === costCenters.find(costCenter => filterFields.centro_de_custo === costCenter.nome).id);
        }

        if(filterFields.plano_de_contas !== "") {
            auxArray = auxArray.filter(obj => obj.plano_de_contas &&  obj.plano_de_contas.id === productsPlans.find(productsPlan => filterFields.plano_de_contas === productsPlan.nome).id);
        }

        if(filterFields.tipo !== "") {
            auxArray = auxArray.filter(obj => obj.tipo === productServices.productTypes.find(productType => filterFields.tipo === productType[1])[0]);

        }

        if(filterFields.status === "Crítico") {
            auxArray = auxArray.filter(obj => obj.quantidade < obj.quantidade_critica);
        }

        else if(filterFields.status === "Normal") {
            auxArray = auxArray.filter(obj => obj.quantidade >= obj.quantidade_critica);
        }

        else{
            auxArray = auxArray.filter(obj => obj.quantidade >= obj.quantidade_critica || obj.quantidade < obj.quantidade_critica);
        }

        props.setProducts(auxArray);
    }

    function onResetFilters() {
        setFilterFields({
            centro_de_custo: "",
            plano_de_contas: "",
            tipo: "",
            status: "Todos",
            nome: "",
            categoria: ""
        });
    }

    function isReseted() {
        for(const key of Object.keys(filterFields)) {
            if (key === "status" && filterFields[key] !== "Todos"){
                return false;                
            }
            else if(key !== "status" && filterFields[key])
                return false;
        }
        return true;
    }


    return (
        <Popup
        visibility={props.visibility}
        setVisibility={props.setVisibility}
        tittle="Filtrar"
        icon={<FaFilter/>}
        >
            <div className='products-filter-container'>
                <Input
                label="Nome"
                type="text"
                placeholder="Digite um nome de produto"
                id="products-filter-name"
                onChange={(e) => setFilterFields({...filterFields, nome: e.target.value})}
                cleanValue=""
                value={filterFields.nome}
                />

                <Input
                label="Centro de Custo"
                type="select"
                id="products-filter-cost-center"
                options={costCenters.map(costCenter => costCenter.nome)}
                onChange={(e) => setFilterFields({...filterFields, centro_de_custo: e.target.value})}
                cleanValue=""
                value={filterFields.centro_de_custo}
                />

                <Input
                label="Plano de Contas"
                type="select"
                id="products-filter-bills-plan"
                options={productsPlans.map(productsPlan => productsPlan.nome)}
                onChange={(e) => setFilterFields({...filterFields, plano_de_contas: e.target.value})}
                cleanValue=""
                value={filterFields.plano_de_contas}
                />

                <Input
                label="Tipo"
                type="select"
                noFilterOptions
                id="products-filter-type"
                options={productServices.productTypes.map(obj => obj[1])}
                onChange={(e) => setFilterFields({...filterFields, tipo: e.target.value})}
                cleanValue=""
                value={filterFields.tipo}
                />
                <Input
                label="Categoria"
                type="select"
                noFilterOptions
                id="products-filter-category"
                options={productServices.productCategories.map(obj => obj[1])}
                onChange={(e) => setFilterFields({...filterFields, categoria: e.target.value})}
                cleanValue=""
                value={filterFields.categoria}
                />

                <Input
                    label="Status"
                    type="select"
                    noFilterOptions
                    id="products-filter-status"
                    options={["Todos", "Normal", "Crítico"]}
                    onChange={(e) => setFilterFields({...filterFields, status: e.target.value})}
                    value={filterFields.status}
                />
            </div>
            
            <button className="blue" onClick={() => {onFilter(); props.setVisibility(false)}}>
                Filtrar
            </button>

            {
                !isReseted() ?
                <button className="red" onClick={() => {onResetFilters()}}>
                    Resetar Filtros
                </button>
                :
                null
            }

        </Popup>

    )

}